// © 2015-2021 WDNA - All Rights Reserved

import Companies from './loaders/Companies';
import Customers from './loaders/Customers';
import Installers from './loaders/Installers';
import Locations from './loaders/Locations';
import System from './loaders/System';

export const redirects: any[] = [
  {
    from: '/management',
    to: '/management/customers',
  },
];

export const routes: any[] = [
  {
    component: Companies,
    path: '/management/companies',
  },
  {
    component: Customers,
    path: '/management/customers',
  },
  {
    component: Installers,
    path: '/management/installers',
  },
  {
    component: Locations,
    path: '/management/locations',
  },
  {
    component: System,
    path: '/management/system',
  },
];
